import React from 'react';

export default function EndPage() {
	return (
		<div className='app'>
			<div className='loading-page'>
				<h1 className='loading-page-title'>תודה רבה על ההשתתפות!</h1>
				<div>
					<img
						src='https://img1.wsimg.com/isteam/ip/96f2bb5f-1f2e-4dd9-9d45-3a3c8bf46fac/%D7%92%D7%A8%D7%A4%D7%99%D7%A7%D7%94%20%D7%9E%D7%A1%D7%9A%20%D7%A1%D7%95%D7%A4%D7%99.png/:/rs=w:1440,h:1440'
						alt=''
					/>
				</div>

				<div className='loading-page-text'>
					בדקו את תיבת המייל שלכם בקרוב... מי יודע, אולי תזכו (:
				</div>
				<div>
					<img
						src='https://img1.wsimg.com/isteam/ip/96f2bb5f-1f2e-4dd9-9d45-3a3c8bf46fac/swu_logo.png/:/rs=w:1440,h:1440'
						alt=''
					/>
				</div>
			</div>
		</div>
	);
}
